import script from "./HtmlCom.vue?vue&type=script&setup=true&lang=js"
export * from "./HtmlCom.vue?vue&type=script&setup=true&lang=js"

import "./HtmlCom.vue?vue&type=style&index=0&id=52b49ac3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b49ac3"]])

export default __exports__